import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,CartesianGrid ,
} from "recharts";
import {Users,TrendingUp} from "lucide-react";
const data = [
  { name: "Mon", Total: 4.76, Warm: 4.50, Current: 4.36, Cold: 3.89 },
  { name: "Tue", Total: 4.90, Warm: 4.44, Current: 4.38, Cold: 4.0 },
  { name: "Wed", Total: 4.98, Warm: 4.56, Current: 4.49, Cold: 4.11 },
  { name: "Thu", Total: 5.12, Warm: 4.65, Current: 4.30, Cold: 4.2 },
  { name: "Fri", Total: 5.16, Warm: 4.68, Current: 4.33, Cold: 4.11 },
  { name: "Sat", Total: 5.14, Warm: 4.73, Current: 4.45, Cold: 4.30 },
  { name: "Sun", Total: 5.18, Warm:4.96, Current: 4.52, Cold:4.20 },

];
const legendLabels = [
    { name: "Total", color: "#1d72f1" },
    { name: "Warm", color: "#e0b423" },
    { name: "Current", color: "#1deba6" },
    { name: "Cold", color: "#ec3434" },
  ]


const Chart = () => {
  return (

    <div className="max-w-sm  bg-white rounded-lg shadow-sm hover:bg-transparent  p-2  ">
   <div className="flex gap-2 font-medium border-b-2 mb-1">
   <Users size={20} color="#000000"/>
   <h2>Sales</h2>
   </div>
      <div className=" mb-2 border-b-2">
      <div className="flex text-base p-1 justify-between bg-[#BDFFBC] text-center rounded-lg font-medium text-textColor"> <h2 c>Current Months</h2>
      <TrendingUp size={20}/></div>
        <div className=" flex justify-between">
          <h5 className="text-base font-bold text-textColor pb-1">
            This month
          </h5>
          <p className="text-sm font-semibold text-textColor pb-1">12</p>
        </div>
        <div className="flex justify-between">
          <p className="text-base font-bold text-red-500 pb-1">
            Total Students
          </p>
          <p className="text-sm font-semibold text-textColor pb-1">299</p>
        </div>
        
      </div>

      {/* ✅ Chart goes here */}
      <div id="legend-chart" className="mb-1">
      <h2 className="text-base font-medium text-textColor pb-1">Sales Forecasts</h2>
        <ResponsiveContainer width="100%" height={210}>
          <LineChart data={data}>
            <XAxis dataKey="name" stroke="#776" />
            <YAxis
              stroke=""
              domain={[3.68, 5.25]}
              reversed={false}
              tickFormatter={(value) => value.toFixed(1)}
              tickCount={7}
            />
            <CartesianGrid stroke="#ddd"  horizontal={true} vertical={false} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="Total"
              stroke="#1d72f1"
              strokeWidth={4}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="Warm"
              stroke="#e0b423"
              strokeWidth={4}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="Current"
              stroke="#1deba6"
              strokeWidth={4}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="Cold"
              stroke="#ec3434"
              strokeWidth={4}
              dot={false}
            />
            
          </LineChart>
        </ResponsiveContainer>
          {/* ✅ Custom Legend Below */}
  <div className="flex flex-wrap items-center gap-4 mt-3">
  {legendLabels.map((item, index) => (
    <div key={index} className="flex items-center gap-2 text-sm text-gray-700">
      <span
        className="inline-block w-3 h-3 rounded-full"
        style={{ backgroundColor: item.color }}
      ></span>
      {item.name}
    </div>
  ))}
</div>
      </div>

     </div>
    
  );
};

export default Chart;
